module.exports = __webpack_public_path__ + "images/emoji/hurtrealbad.3a9763040f4d724ecbd5.png";